import { Component } from '@angular/core';
import { Modal } from 'src/app/models/Modal.model';
import { ModalNames } from '../Modal';

@Component({
    templateUrl: './learning-shortcut.modal.html'
})
export class LearningShortcutModalComponent extends Modal {

    onInjectInputs(): void {
        return null;
    }

    allowDimmerClose(): boolean {
        return true;
    }
  
    getName(): ModalNames {
        return ModalNames.LEARNING_SHORTCUT;
    }
}